export default __webpack_public_path__ + "static/media/020_start.3744b23a.mp4";